import React from 'react'

const mapContext = React.createContext()

export const MapContextProvider = mapContext.Provider
export const MapContextConsumer = mapContext.Consumer

export const withMapContext = (Component) => (
	(props) => (
	    <MapContextConsumer>
	        { (map) => <Component {...props} map={map} /> }
	    </MapContextConsumer>
	)
)


// WEBPACK FOOTER //
// ./src/components/Leaflet/mapContext.js